import React from 'react'
import './LoadingScreen.css'

const LoadingScreen = () => {
  return (
    <div className="loading-screen">
      <div className="loading-spinner-large"></div>
      <p>Loading...</p>
    </div>
  )
}

export default LoadingScreen

